module.exports = __webpack_public_path__ + "static/media/Travel.8a387f9e.jpg";